import {REGEX_GRAVIUR, REGEX_GRAVIUR_REPLACE} from "../constants/common";

function readPatternFromLocalStorage() {
  try {
    const raw = localStorage.getItem("groupOrder");

    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const configs = parsed?.configs || null;

    const pattern = configs?.gravur_characters_allow;

    if (typeof pattern === "string") {
      return `^[${pattern}]+$`;
    }
    return null;
  } catch (_e) {
    return null;
  }
}

export function getGravurRegex() {
    const pattern = readPatternFromLocalStorage();

    if (pattern) {
        return RegExp(pattern);
    }

    return RegExp(REGEX_GRAVIUR);
}

export function getGravurReplaceRegex() {
  const pattern = readPatternFromLocalStorage();

  if (pattern) {
      return RegExp(pattern)
  }

  return RegExp(REGEX_GRAVIUR_REPLACE);
}
